import React, { memo } from 'react';
import MediaDisplay from '@/components/media/MediaDisplay';
import ResponsiveImage from '@/components/media/ResponsiveImage';

function GallerySlide({ item, index, total, isMobile, isNear, onOpen }) {
  const isVideo = item.type === 'video';
  const shouldLoad = !isMobile || isNear;
  // Mobile preserves the photograph's original ratio; desktop remains unchanged.
  const frameClass = isMobile
    ? 'flex max-h-[75vh] max-h-[75dvh] w-screen items-center justify-center bg-white'
    : 'h-[350px] overflow-hidden rounded-[10px] bg-white lg:h-[550px]';
  const imgClass = isMobile
    ? 'h-auto max-h-[75vh] max-h-[75dvh] w-auto max-w-full object-contain'
    : 'h-full w-auto max-w-none object-contain';

  return <div className={frameClass}>
    {isVideo ? <div className={isMobile ? 'flex max-h-[75vh] max-h-[75dvh] w-screen items-center justify-center' : 'h-full aspect-video'}>
      {shouldLoad && <MediaDisplay type="video" url={item.src} meta={item.meta} controls className="max-h-[75vh] max-h-[75dvh] w-full object-contain" />}
    </div> : <button type="button" onClick={() => onOpen(item)} aria-label={`Apri ${item.alt}, immagine ${index + 1} di ${total}`} className={`cursor-zoom-in focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${isMobile ? 'flex w-screen items-center justify-center' : 'block h-full w-auto'}`}>
      {shouldLoad
        ? <ResponsiveImage src={item.src} responsive={item.responsive} alt={item.alt} className={imgClass} imgProps={{ width: item.width, height: item.height, loading: isMobile || isNear ? 'eager' : 'lazy', fetchPriority: isMobile && index === 0 ? 'high' : 'auto', decoding: 'async', draggable: false, sizes: isMobile ? '100vw' : 'auto' }} />
        : <img alt="" width={item.width} height={item.height} loading="lazy" decoding="async" draggable="false" className={imgClass} />}
    </button>}
  </div>;
}

export default memo(GallerySlide);